<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :width="width"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <div class="left" v-if="curItem.type == 1">
        <el-form :model="formInline" ref="form" :rules="rules">
          <el-form-item label="事项名称" prop="ghEventManageId">
            <el-select
              placeholder="请选择事项名称"
              v-model="formInline.ghEventManageId"
              filterable
            >
              <el-option
                v-for="item in eventList"
                :key="item.id"
                :label="item.sxmc"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指标名称" prop="zbmc">
            <el-input
              v-model="formInline.zbmc"
              placeholder="请输入指标名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="分值/权重">
            <el-input
              v-model="formInline.fzqz"
              placeholder="请输入分值/权重"
            ></el-input>
          </el-form-item>
          <el-form-item label="考核对象(指标类型)">
            <el-input
              v-model="formInline.khdx"
              placeholder="请输入考核对象(指标类型)"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="指标选项(评分标准)" prop="zbxs">
            <el-input
              type="textarea"
              show-word-limit
              style="white-space: pre-wrap;"
              ref="zbxs"
              maxlength="200"
              :autosize="{ minRows: 4, maxRows: 8 }"
              v-model="formInline.zbxs"
              placeholder="请输入指标选项(评分标准)"
            >
            </el-input>
          </el-form-item> -->
          <el-form-item label="大循环上报规则">
            <el-input
              type="textarea"
              show-word-limit
              style="white-space: pre-wrap;"
              ref="zbsm"
              maxlength="200"
              :autosize="{ minRows: 4}"
              v-model="formInline.zbsm"
              placeholder="请输入大循环上报规则"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="right-box">
        <div class="table-box">
          <div class="title">指标应用点位列表</div>
          <el-form
            :inline="true"
            label-position="left"
            class="demo-form-inline"
            :model="form"
          >
            <el-form-item label="">
              <el-select
                filterable
                placeholder="点位类型"
                clearable
                style="width: 120px;"
                v-model="form.pointType"
              >
                <el-option
                  v-for="item in pointTypeOptions"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select
                filterable
                placeholder="所属社区"
                clearable
                style="width: 120px;"
                v-model="form.deptCode"
              >
                <el-option
                  v-for="item in commcommunityList"
                  :key="item.code"
                  :label="item.pointName"
                  :value="item.deptCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="">
              <el-select
                filterable
                placeholder="所属网格"
                clearable
                style="width: 120px;"
                v-model="form.blockCode"
              >
                <el-option
                  v-for="item in blockList"
                  :key="item.code"
                  :label="item.pointName"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="">
              <el-input
                v-model="form.pointName"
                clearable
                placeholder="请输入点位名称"
              >
                <el-button
                  style=" background: #0495FF;
                          border-radius: 0px 4px 4px 0px;
                          color: #FFFFFF;"
                  slot="append"
                  icon="el-icon-search"
                  @click="getPointLevelListPageFun"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-form>
          <common-table
            :select="true"
            :page="page"
            :dataList="dataList"
            :selectedIdOptions="selectedIdOptions"
            :maxHeight="500"
            :delSelected="delSelected"
            :checkListOptions="checkListOptions"
            @handleSelectionChange="handleSelectionChange"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            @selectAll="selectAll"
          >
            <template v-slot:pointTypes="{ scope }">
              <span>{{ getPointTypeName(scope.row.pointTypes) }}</span>
            </template>
          </common-table>
        </div>
        <div class="point">
          <div class="title">
            <span>已选点位</span>
            <el-button type="text" @click="bitchSelect">批量删除</el-button>
          </div>
          <div class="selected-box">
            <el-checkbox-group v-model="checkList">
              <div
                class="selected-box-item"
                v-for="(item, index) in selectedOptions"
                :key="index"
              >
                <el-checkbox :label="item.id">
                  <div
                    style="width: 220px;display: flex;justify-content: space-between;align-items: center;"
                  >
                    <span>{{ item.pointName }}</span>
                    <div @click="delPoints(item)" class="del-bt">-</div>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {
  eventPage,
  editAndModifyPointRel,
  indexDetail,
  modifyPointRel
} from "@/api/base.js";
import { getPointLevelListPage } from "@/api/point.js";
import commonTable from "@/components/table/index.vue";
import index from "./index.js";
import pageChangeSelect from "@/mixins/page-change-select.js";
export default {
  components: {
    commonTable
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    },
    ghEventIndexIdList: {
      type: Array,
      default: []
    }
  },
  mixins: [index, pageChangeSelect],
  data() {
    return {
      title: "新增事项标准",
      width: "1440px",
      formInline: {
        ghEventManageId: "",
        zbmc: "",
        fzqz: "",
        khdx: "",
        zbxs: "",
        zbsm: "",
        id: ""
      },
      rules: {
        ghEventManageId: [
          { required: true, message: "请选择事项名称", trigger: "blur" }
        ],
        zbmc: [
          {
            required: true,
            message: "请输入指标名称(考评内容)",
            trigger: "blur"
          }
        ],
        zbxs: [
          {
            required: true,
            message: "请输入指标选项(评分标准)",
            trigger: "blur"
          }
        ]
      },
      form: {
        pointType: "",
        deptCode: "",
        // blockCode: "",
        pointName: ""
      },
      deptCode: "",
      dataList: {
        tableData: [],
        columns: [
          {
            slot: "pointTypes",
            label: "点位类型"
          },
          {
            prop: "levelName2",
            label: "所属社区"
          },
          // {
          //   prop: "levelName3",
          //   label: "所属网格"
          // },
          {
            prop: "pointName",
            label: "点位名称"
          }
        ]
      },

      eventList: [],
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      delSelected: {},
      checkList: [],
      checkListOptions: []
    };
  },
  mounted() {
    if (this.curItem.type == 1) {
      if (this.curItem && this.curItem.id) {
        this.title = "编辑事项标准";
        this.indexDetailFun();
      } else {
        this.title = "新增事项标准";
        this.getPointLevelListPageFun();
      }
      this.getCommcommunityAllFun();
      this.getPointTypeListPageFun();
      this.eventPageFun();
    } else {
      this.title = "批量关联点位";
      this.width = "1120px";
      this.getPointLevelListPageFun();
    }
  },
  methods: {
    onSearch() {},
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    delPoints(item) {
      this.selectedOptions = this.selectedOptions.filter(
        itm => itm.id != item.id
      );
      this.selectedIdOptions = this.selectedIdOptions.filter(
        itm => itm != item.id
      );
      this.delSelected = item;
    },
    bitchSelect() {
      console.log(this.checkList, "this.checkList");

      if (this.checkList.length) {
        this.checkListOptions = this.selectedOptions.filter(
          itm => this.checkList.includes(itm.id)
        );
        this.selectedOptions = this.selectedOptions.filter(
          itm => !this.checkList.includes(itm.id)
        );

        this.selectedIdOptions = this.selectedIdOptions.filter(
          itm => !this.checkList.includes(itm.id)
        );
      }
    },
    async indexDetailFun() {
      const res = await indexDetail({
        id: this.curItem.id
      });
      this.formInline = res.data.data;

      this.selectedOptions = [];
      this.selectedIdOptions = [];
      if (
        this.formInline.ghEventIndexPointRelList &&
        this.formInline.ghEventIndexPointRelList.length
      ) {
        this.formInline.ghEventIndexPointRelList.forEach(item => {
          this.selectedIdOptions.push(item.ghPointLevelId);
          this.selectedOptions.push({
            id: item.ghPointLevelId,
            pointName: item.ghPointLevelName
          });
        });
      }
      this.getPointLevelListPageFun();
    },
    async eventPageFun() {
      const res = await eventPage({
        page: 1,
        size: 99999,
        ghEventTypeId: 'd10c6dde183291179f06113d400f08bb'
      });
      if (res.data.code == 200) this.eventList = res.data.data.records;
    },
    async addOrUpdateFun() {
      let res = null;
      let ghPointLevelIdList = this.selectedOptions.length
        ? this.selectedOptions.map(item => item.id)
        : [];
      if (this.curItem.type == 1) {
        let xx = true;
        this.$refs["form"].validate(valid => {
          if (valid) {
            xx = true;
          } else {
            xx = false;
          }
        });
        if (xx == false) {
          this.$message({
            message: "请输入或选择必填项",
            type: "warning"
          });
          return false;
        }

        let params = {
          ghEventManageId: this.formInline.ghEventManageId,
          zbmc: this.formInline.zbmc,
          fzqz: this.formInline.fzqz,
          khdx: this.formInline.khdx,
          zbxs: this.formInline.zbxs,
          zbsm: this.formInline.zbsm,
          ghPointLevelIdList: ghPointLevelIdList,
          id: this.formInline.id
        };
        res = await editAndModifyPointRel(params);
      } else {
        let params = {
          ghEventIndexIdList: this.ghEventIndexIdList,
          ghPointLevelIdList: ghPointLevelIdList
        };
        res = await modifyPointRel(params);
      }
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointLevelListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointLevelListPageFun();
    },
    // 分页查询
    async getPointLevelListPageFun() {
      let params = {
        page: this.page.page,
        size: this.page.size,
        ...this.form,
        deptCode: this.form.deptCode
      };
      const res = await getPointLevelListPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  },
  computed: {},
  watch: {
    "formInline.zbxs": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (!!!newVal) return;

        this.$nextTick(() => {
          const inputElement = this.$refs.zbxs.$el.querySelector("textarea");
          const cursorPosition = inputElement.selectionStart;
          this.formInline.zbxs = newVal.replace(/ /g, "\u3000");
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    },
    "formInline.zbsm": {
      deep: true,
      handler: function(newVal, oldVal) {
        if (!!!newVal) return;

        this.$nextTick(() => {
          const inputElement = this.$refs.zbsm.$el.querySelector("textarea");
          const cursorPosition = inputElement.selectionStart;
          this.formInline.zbsm = newVal.replace(/ /g, "\u3000");
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/ .el-textarea__inner {
  padding: 15px !important;
}
/deep/ .el-textarea .el-input__count {
  color: #909399;
  background: transparent;
  position: absolute;
  font-size: 12px;
  bottom: -10px;
  right: 10px;
}

/deep/.el-dialog__body {
  padding: 24px;
  overflow: hidden;
}
.container-dialog {
  overflow: hidden;
  display: flex;
  .left {
    width: 320px;
    height: 660px;
    overflow: auto;
    margin-right: 24px;
  }
  .right-box {
    width: 1048px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    display: flex;
    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    > div {
      padding: 20px;
    }
    .table-box {
      width: 780px;
      height: 700px;
      overflow: auto;
      border-right: 1px solid #e0e0e0;
      position: relative;
    }
    .point {
      width: 292px;
      height: 700px;
      overflow: auto;
      .selected-box {
        width: 100%;
        .selected-box-item {
          height: 52px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .del-bt {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: #e0e0e0;
            display: flex;
            justify-content: center;
            line-height: 15px;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
  }
}
/deep/.el-checkbox {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/baseInfo/issuesStandardManagement/components/addDialog.vue